// processors.ts
import StandardChartSpecProcessor from './processors/StandardChartSpecProcessor';
import NormalSpecProcessor from './processors/NormalSpecProcessor';
import HXKLineSpecProcessor from './processors/HXKLineSpecProcessor';
import ExternalSpecProcessor from './processors/ExternalSpecProcessor';
import { type Spec, type Data } from './processors/specProcessor';
import { getLayer } from '../layer';

// 定义处理器类型增强类型安全
type ProcessorType = {
  test: (layer: ReturnType<typeof getLayer>) => boolean;
  processor:
    | typeof StandardChartSpecProcessor
    | typeof NormalSpecProcessor
    | typeof HXKLineSpecProcessor
    | typeof ExternalSpecProcessor;
};

// 配置化处理器列表，便于扩展
const PROCESSORS: ProcessorType[] = [
  {
    test: layer => !!layer.isStandardChartLayer,
    processor: StandardChartSpecProcessor
  },
  {
    test: layer => !!layer.isNormalLayer,
    processor: NormalSpecProcessor
  },
  {
    test: layer => !!layer.isHXKLineLayer,
    processor: HXKLineSpecProcessor
  },
  {
    test: layer => !!layer.isExternalLayer,
    processor: ExternalSpecProcessor
  }
];

// 核心处理逻辑
export default function preprocessing(data: Data, spec: Spec): boolean {
  return spec.layers.some(layerSpec => {
    const layer = getLayer(layerSpec.type);
    if (!layer) {
      console.warn(`No layer found for type: ${layerSpec.type}`);
      return false;
    }
    const matched = PROCESSORS.find(p => p.test(layer));
    if (!matched) {
      console.warn(`No processor found for layer type: ${layerSpec.type}`);
      return false;
    }

    try {
      return matched.processor.preprocessing(data, spec);
    } catch (error) {
      console.error(`Processor failed on ${layerSpec.type}:`, error);
      return false;
    }
  });
}
